import React from 'react';

export default function Show(props) {
  const { children, when } = props;

  const allow = React.useMemo(() => {
    if (when) return true;
    return false;
  }, [when]);

  React.useDebugValue({ when, allow });

  return allow && (children ?? null);
}
